/**
 * Configuration loader for Hermes components
 * Provides access to environment-specific and global configurations
 */

// Load environment-specific configuration
const env = process.env.NODE_ENV || 'local'
let envConfig = {}

try {
  envConfig = require(`@/../config/${env}.env.js`)
} catch (error) {
  console.warn(`Environment config not found for ${env}, falling back to local`)
  try {
    envConfig = require('@/../config/local.env.js')
  } catch (fallbackError) {
    console.error('Could not load any environment configuration:', fallbackError)
  }
}

// Load global configuration
let globalConfig = {}
try {
  globalConfig = require('@/../config/global.js')
} catch (error) {
  console.error('Could not load global configuration:', error)
}

// Merge configurations
const config = Object.assign({}, globalConfig, envConfig)

export default config


// WEBPACK FOOTER //
// ./src/utils/config.js